import { Component, inject, ChangeDetectionStrategy } from '@angular/core';

import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import {
    SHUI_MODAL_CONFIG,
    ShButtonComponent,
    ShInputTextComponent,
    ShuiModalConfig,
    ShuiModalRef,
    TextValueAccessor
} from '@gbr-monorepo/gbr-shui';
import { TranslateModule } from '@ngx-translate/core';
import { UserApplication } from '@gbr-monorepo/interfaces';

@Component({
    selector: 'app-comment-dialog',
    imports: [ReactiveFormsModule, ShInputTextComponent, ShButtonComponent, TextValueAccessor, TranslateModule],
    changeDetection: ChangeDetectionStrategy.Eager,
    templateUrl: './comment-dialog.component.html'
})
export class CommentDialogComponent {
    protected readonly config = inject<ShuiModalConfig<UserApplication>>(SHUI_MODAL_CONFIG);
    private readonly modalRef = inject<ShuiModalRef<string>>(ShuiModalRef);

    protected formGroup = new FormGroup({
        comment: new FormControl(this.config.data?.comment || '', { nonNullable: true })
    });

    public clearComment(): void {
        this.formGroup.patchValue({ comment: '' });
    }

    public onClose(result?: string): void {
        if (result) {
            this.modalRef.close(this.formGroup.value.comment);
            return;
        }

        this.modalRef.close();
    }
}
